module.exports = __webpack_public_path__ + "img/ls-fatigue-cr2.74e6e945.jpg";